
export default {
    SET_USER: function (state, user) {
        state.user = user;
    }
}
